import React from 'react';
import { Link } from 'react-router-dom';
const services = [{
  label: 'Mobile Detailing',
  to: '/services/mobile-detailing'
}, {
  label: 'Interior Detailing',
  to: '/services/interior-detailing'
}, {
  label: 'Exterior Detailing',
  to: '/services/exterior-detailing'
}, {
  label: 'Full Car Detail',
  to: '/services/full-car-detail'
}, {
  label: 'Engine Bay Detailing',
  to: '/services/engine-bay-detailing'
}, {
  label: 'Headlight Restoration',
  to: '/services/headlight-restoration'
}, {
  label: 'Hybrid Ceramic Spray',
  to: '/services/hybrid-ceramic-spray'
}];
const citiesList = [{
  label: 'Camarillo',
  to: '/mobile-detailing-camarillo'
}, {
  label: 'Oxnard',
  to: '/mobile-detailing-oxnard'
}, {
  label: 'Ventura',
  to: '/mobile-detailing-ventura'
}, {
  label: 'Thousand Oaks',
  to: '/mobile-detailing-thousand-oaks'
}, {
  label: 'Simi Valley',
  to: '/mobile-detailing-simi-valley'
}, {
  label: 'Moorpark',
  to: '/mobile-detailing-moorpark'
}, {
  label: 'Newbury Park',
  to: '/mobile-detailing-newbury-park'
}, {
  label: 'Westlake Village',
  to: '/mobile-detailing-westlake-village'
}];
export function SeoContent() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" aria-labelledby="seo-content-heading" data-id="element-326" data-mp="3i09yd6fx2ycq">
      <div className="max-w-4xl mx-auto" data-id="element-327" data-mp="3rs5wghi06ogy">
        <div className="prose prose-invert prose-lg max-w-none prose-headings:font-black prose-headings:uppercase prose-headings:tracking-tight prose-h2:text-3xl md:prose-h2:text-4xl prose-h2:mb-5 prose-h2:mt-12 first:prose-h2:mt-0 prose-h3:text-xl prose-h3:text-yellow-400 prose-p:text-gray-300 prose-p:leading-relaxed prose-li:text-gray-300 prose-strong:text-white prose-a:text-red-500 hover:prose-a:underline" data-id="element-328" data-mp="3rt7g3ad34jaa">
          <h2 id="seo-content-heading" data-id="element-329" data-mp="el45r4eipnlo">
            Mobile Detailing in Ventura County, Done Right
          </h2>
          <p data-id="element-330" data-mp="2bg0kktpq7720">
            <strong data-id="element-331" data-mp="2bgacwny8tqav">Mike's Pro Detail</strong> is a premium{' '}
            <strong data-id="element-332" data-mp="2gdivuqr7tyd6">mobile car detailing</strong> company proudly serving{' '}
            <strong data-id="element-333" data-mp="3joy1fh04s4e7">Ventura County, California</strong>. We bring a fully
            equipped, professional detail shop directly to your driveway, so you
            get a flawless, showroom-quality finish without ever leaving home.
            From{' '}
            <Link to="/mobile-detailing-camarillo" data-id="element-334" data-mp="3sm8f190f85ma">
              mobile detailing in Camarillo
            </Link>{' '}
            and{' '}
            <Link to="/mobile-detailing-oxnard" data-id="element-335" data-mp="6glage2esdwk">car detailing in Oxnard</Link> to{' '}
            <Link to="/mobile-detailing-ventura" data-id="element-336" data-mp="1itijk1rkrsd">auto detailing in Ventura</Link>
            ,
            our mobile team comes to you with our own water, detailing
            equipment, and premium eco-friendly products. There is no
            drop-off, no waiting room, and no compromise on quality.
          </p>
          <p data-id="element-337" data-mp="p8xi9gbu07e3">
            Whether you searched for <em data-id="element-338" data-mp="p5rv46mrjfl0">"car detailing near me"</em>,{' '}
            <em data-id="element-339" data-mp="k9ko0aimry1h">"mobile car detailing Ventura County"</em>, or a specific
            service in your city, you have found the most trusted name in local
            auto detailing. We treat every vehicle as if it were our own,
            combining meticulous hand work with professional-grade equipment to
            deliver results that protect your investment and turn heads.
          </p>

          <h2 data-id="element-340" data-mp="yup15a0q1yl3">Why Choose Mobile Detailing?</h2>
          <p data-id="element-341" data-mp="ytnfycpzrvpn">
            Traditional car washes are fast but harsh — automated brushes and
            recycled water can leave swirl marks and scratches in your clear
            coat. Professional mobile detailing is the opposite: a careful,
            hand-crafted process performed right where you live or work.
            Choosing{' '}
            <Link to="/services/mobile-detailing" data-id="element-342" data-mp="g4h3h7fsk0ca">
              mobile detailing in Ventura County
            </Link>{' '}
            gives you several major advantages:
          </p>
          <ul data-id="element-343" data-mp="66ktiiylbbfr">
            <li data-id="element-344" data-mp="67cgj5e4g0uf">
              <strong data-id="element-345" data-mp="65riv6wig1sc">Convenience:</strong> We come to your home, office, or
              apartment. You reclaim hours of your day instead of sitting at a
              shop.
            </li>
            <li data-id="element-346" data-mp="3q9ntlf4r21wu">
              <strong data-id="element-347" data-mp="3qb8ox6yw1ovr">Quality:</strong> Hand washing, clay bar decontamination,
              and careful interior work that automated washes simply cannot
              match.
            </li>
            <li data-id="element-348" data-mp="3gjcmjjprrclq">
              <strong data-id="element-349" data-mp="3gjufo7h4xapf">We bring the equipment:</strong> We bring our own water
              and detailing equipment. We require access to a standard
              electrical outlet at the service location.
            </li>
            <li data-id="element-350" data-mp="37lskw9nzveal">
              <strong data-id="element-351" data-mp="32k374m9e0mit">Protection:</strong> Premium waxes, sealants, and ceramic
              coatings that shield your paint from the Southern California sun
              and coastal salt air.
            </li>
          </ul>

          <h2 data-id="element-352" data-mp="10t89rpzj8f9z">Our Professional Detailing Services</h2>
          <p data-id="element-353" data-mp="10qm2lrgk01sa">
            We offer a complete range of mobile detailing services for cars,
            trucks, and SUVs across Ventura County. Each service is performed
            on-site and tailored to your vehicle's specific needs.
          </p>

          <h3 data-id="element-354" data-mp="18bfvmf9u5z0f">Interior Detailing</h3>
          <p data-id="element-355" data-mp="18aej06d694gl">
            Our{' '}
            <Link to="/services/interior-detailing" data-id="element-356" data-mp="1d3hb0a2aw5uo">interior detailing</Link>{' '}
            service deep cleans, shampoos, steam sanitizes, and conditions every
            surface inside your cabin. We remove embedded dirt, pet hair,
            stains, and odors, restoring a fresh, like-new feel while improving
            the air quality you breathe on every drive.
          </p>

          <h3 data-id="element-357" data-mp="ucpy4yj3txbj">Exterior Detailing</h3>
          <p data-id="element-358" data-mp="ubojyl6skupl">
            Our{' '}
            <Link to="/services/exterior-detailing" data-id="element-359" data-mp="ueswc5ueuwrc">exterior detailing</Link>{' '}
            service includes a safe hand wash, clay bar treatment, wheel and
            tire cleaning, and a durable wax or sealant. This safely removes
            bonded contaminants, restores deep gloss, and protects your paint
            from UV damage and oxidation.
          </p>

          <h3 data-id="element-360" data-mp="1l1j2et3xutwf">Full Car Detail</h3>
          <p data-id="element-361" data-mp="1l4x37wwyev1r">
            Our most popular package, the{' '}
            <Link to="/services/full-car-detail" data-id="element-362" data-mp="1g2y10qcya46e">full car detail</Link>,
            combines our complete interior and exterior services for a true
            bumper-to-bumper transformation. It is the most cost-effective way
            to completely reset your vehicle's condition inside and out.
          </p>

          <h3 data-id="element-363" data-mp="12cuj2bl3swmr">Engine Bay Detailing</h3>
          <p data-id="element-364" data-mp="xd9oedcyvafu">
            Our{' '}
            <Link to="/services/engine-bay-detailing" data-id="element-365" data-mp="xeaz2gq2lux1">
              engine bay detailing
            </Link>{' '}
            safely degreases and cleans your engine compartment, making it
            easier to spot leaks, helping prevent heat-trapping grime, and
            dramatically improving your vehicle's presentation and resale value.
          </p>

          <h3 data-id="element-366" data-mp="emrx8d7s8mwl">Headlight Restoration</h3>
          <p data-id="element-367" data-mp="elp7w9q3ysis">
            Cloudy, yellowed headlights are both an eyesore and a safety hazard.
            Our{' '}
            <Link to="/services/headlight-restoration" data-id="element-368" data-mp="2q8iy7ra1z41q">
              headlight restoration
            </Link>{' '}
            service permanently removes oxidation and restores crystal-clear
            lenses, improving your nighttime visibility and your car's
            appearance.
          </p>

          <h3 data-id="element-369" data-mp="2lbk2x5enkr1y">Hybrid Ceramic Spray Protection</h3>
          <p data-id="element-370" data-mp="390uzsbsvu1at">
            Our{' '}
            <Link to="/services/hybrid-ceramic-spray" data-id="element-371" data-mp="391wm5cfcma7u">
              hybrid ceramic spray protection
            </Link>{' '}
            is sprayed on by hand at the end of a detail, adding gloss and
            helping your paint shed water and dirt. It is included in our Wash
            &amp; Wax and Full Detail packages.
          </p>

          <h2 data-id="element-372" data-mp="343d07c0r8yfh">Serving All of Ventura County</h2>
          <p data-id="element-373" data-mp="1ojovjyqhiujq">
            As a mobile operation, we bring our detailing service to every
            community in Ventura County. Wherever you are, we come to you with a
            complete, professional detail. Explore our dedicated city pages for
            local information and pricing:
          </p>
          <div className="not-prose grid grid-cols-2 sm:grid-cols-4 gap-3 my-8" data-id="element-374" data-mp="2fa1zrr173kwh">
            {citiesList.map(c => <Link key={c.to} to={c.to} className="block text-center px-3 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold text-sm hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-375" data-mp="2ba1a1a8nbna4">
                {c.label}
              </Link>)}
          </div>
          <p data-id="element-376" data-mp="2yykk9vb9aa4u">
            We provide{' '}
            <Link to="/mobile-detailing-camarillo" data-id="element-377" data-mp="2z0x8urbiriqv">
              mobile detailing in Camarillo
            </Link>
            ,{' '}
            <Link to="/mobile-detailing-oxnard" data-id="element-378" data-mp="2p99eoinkvnlp">car detailing in Oxnard</Link>,{' '}
            <Link to="/mobile-detailing-ventura" data-id="element-379" data-mp="3moes1ygpx8i8">auto detailing in Ventura</Link>
            ,{' '}
            <Link to="/mobile-detailing-thousand-oaks" data-id="element-380" data-mp="3hxoq6v7i3nsa">
              detailing in Thousand Oaks
            </Link>
            , <Link to="/mobile-detailing-simi-valley" data-id="element-381" data-mp="3p9csrkao12qn">Simi Valley</Link>,{' '}
            <Link to="/mobile-detailing-moorpark" data-id="element-382" data-mp="3u7wg9p4wqml4">Moorpark</Link>,{' '}
            <Link to="/mobile-detailing-newbury-park" data-id="element-383" data-mp="3u869dll919v1">Newbury Park</Link>, and{' '}
            <Link to="/mobile-detailing-westlake-village" data-id="element-384" data-mp="30trf4cjkse2">
              Westlake Village
            </Link>
            .
          </p>

          <h2 data-id="element-385" data-mp="70vikjkni3f3">Why Ventura County Trusts Mike's Pro Detail</h2>
          <p data-id="element-386" data-mp="c1i15muwk6l5">
            With a 5-star reputation built across Ventura County, Full Detail
            Pro has earned the loyalty of drivers who demand the very best for
            their vehicles. Our success comes down to a simple philosophy:
            uncompromising quality, genuine convenience, and treating every
            customer's car with the same care we would give our own. We use only
            premium, eco-friendly products and professional-grade equipment, and
            we never rush a job — because a truly great detail takes time and
            attention.
          </p>
          <p data-id="element-387" data-mp="22rsempu0o5xp">
            Our experienced technicians understand the unique challenges of
            Southern California vehicles: relentless UV exposure that fades
            paint and cracks interiors, coastal salt air that accelerates
            corrosion, and fine inland dust that works its way into every
            surface. Every service we provide is designed to combat these
            conditions and keep your vehicle protected, beautiful, and holding
            its value for years to come.
          </p>

          <h2 data-id="element-388" data-mp="2qi4t6jjrp0x9">How Our Mobile Detailing Process Works</h2>
          <p data-id="element-389" data-mp="2vg6ap01jos6m">
            Booking is simple. Call or text Mike directly, describe your vehicle
            and the service you need, and we will provide a clear quote and find
            a time that works for you — including weekends. On the day of your
            appointment, our fully equipped mobile unit arrives at your home or
            office with everything required to complete the detail on-site. You
            stay productive or relax while we transform your vehicle, and you
            inspect the results before we leave. It is professional auto
            detailing made effortless.
          </p>

          <h2 data-id="element-390" data-mp="3aio7a7oz9wiq">Book Your Mobile Detail Today</h2>
          <p data-id="element-391" data-mp="35jblzrdr8xi9">
            Ready to experience the convenience and quality of mobile detailing
            in Ventura County? Whether you need a quick maintenance wash, a
            complete full detail, or specialty services like hybrid ceramic
            spray protection and headlight restoration, Mike's Pro Detail is ready
            to bring the shop to you. Call or text <a href="tel:8183819905" data-id="element-392" data-mp="3taqslwcke0zb">(818) 381-9905</a>{' '}
            today, or <a href="/#contact-form" data-id="element-393" data-mp="3o8rnagx9ktzq">request a free quote online</a>,
            and discover why drivers throughout Camarillo, Oxnard, Ventura,
            Thousand Oaks, and all of Ventura County trust us with their
            vehicles.
          </p>
        </div>
      </div>
    </section>;
}